export class ShareButtons {
  private el: HTMLElement;
  private abortController: AbortController;
  private timeoutID: ReturnType<typeof setTimeout> | null = null;
  private shareLinks: NodeListOf<HTMLElement>;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
    this.shareLinks = this.el.querySelectorAll<HTMLElement>(".js-share-link");
  }

  init(): void {
    const signal = this.abortController.signal;

    const shareIconWrapper = this.el.querySelector<HTMLElement>(".share-icon-wrapper");
    if (shareIconWrapper) {
      shareIconWrapper.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.open();
      }, { signal });
    }

    const iconWrapper = this.el.querySelector<HTMLElement>(".icon-wrapper");
    if (iconWrapper) {
      iconWrapper.addEventListener("mouseover", () => this.stopTimeout(), { signal });
      iconWrapper.addEventListener("mousemove", () => this.stopTimeout(), { signal });
      iconWrapper.addEventListener("mouseleave", () => this.startTimeout(), { signal });
    }

    this.shareLinks.forEach((link) => {
      link.addEventListener("click", this.onShareLinkClick, { signal });
    });
  }

  private startTimeout(): void {
    this.timeoutID = setTimeout(() => {
      if (this.el.classList.contains("open")) {
        this.close();
      }
    }, 4000);
  }

  private stopTimeout(): void {
    if (this.timeoutID) {
      clearTimeout(this.timeoutID);
      this.timeoutID = null;
    }
  }

  private open(): void {
    setTimeout(() => {
      this.el.classList.add("overflow-visible");
    }, 500);
    this.el.classList.add("open");
    const shareIconWrapper = this.el.querySelector<HTMLElement>(".share-icon-wrapper");
    if (shareIconWrapper) {
      shareIconWrapper.classList.add("state-hidden");
    }
    this.startTimeout();
  }

  private close(): void {
    this.el.classList.remove("overflow-visible");
    this.el.classList.remove("open");

    const handler = (): void => {
      const shareIconWrapper = this.el.querySelector<HTMLElement>(".share-icon-wrapper");
      if (shareIconWrapper) {
        shareIconWrapper.classList.remove("state-hidden");
      }
      this.el.removeEventListener("transitionend", handler);
    };
    this.el.addEventListener("transitionend", handler);

    this.stopTimeout();
  }

  private onShareLinkClick = (event: Event): void => {
    if (!event || !event.currentTarget) return;

    const clickedLink = event.currentTarget as HTMLElement;
    const shareType = clickedLink.dataset.service;
    const link = clickedLink.getAttribute("href");

    switch (shareType) {
      case "email":
        break;
      default:
        event.preventDefault();
        if (link) this.openWindow(link);
    }
  };

  private openWindow(link: string): void {
    const w = window.open(
      link,
      "_blank",
      "noopener,noreferrer,height=400,width=600,status=yes,toolbar=no,menubar=no,location=no",
    );
    if (w) w.opener = null;
  }

  destroy(): void {
    this.stopTimeout();
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="share-buttons"]')
      .forEach((el) => {
        new ShareButtons(el).init();
      });
  }
}
